import React from 'react'
import { H3 } from '@components/Globals'
import { Column } from '@components/Common'
import {
  CardsAndArticleContainer,
  RowContainer,
} from '@components/InsightsDetail/style'
import Card, { ProfileCard } from '@components/Card/index'
import Cards from '@components/Cards/index'
import A from '@components/A'
import { findEmailLength } from '@utils'
import Box from '@components/Box'

const InsightsDetailNextTeaser = ({
  next,
  pageSlugs,
  contentType,
  associatedProfessionals,
  refactoredPreview,
  category,
}) => {
  const next1 = next?.[0]
  const removeProDups =
    associatedProfessionals?.length > 0 &&
    associatedProfessionals.reduce((acc, current) => {
      const pro = acc.find(item => item.id === current.id)
      if (!pro && current.active) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

  const lengthOfEmail =
    removeProDups?.length > 0 && findEmailLength(removeProDups)

  if (refactoredPreview) {
    return (
      <Box pl={[0, 0, 0, 4]} fontStyle="italic" color="#5f6062">
        Related Article Entries will not displayed for preview.
      </Box>
    )
  }

  return (
    <CardsAndArticleContainer>
      <RowContainer>
        {next1 && (
          <Column className="sm:w-5/6">
            <H3 color="grayMd" className="qtph-insightspge-readnexttitle-txt">
              {next1.header || 'READ NEXT'}
            </H3>
            <A
              to={next1?.slug}
              contentType={contentType}
              category={next1?.category?.slug}
            >
              <Card title={next1.title} item={next1} id={next1?.slug?.id} />
            </A>
          </Column>
        )}
        {removeProDups && category?.id !== '3poqqp7nKnOpBnfKOFFcNB' && (
          <Column className="sm:w-5/6">
            <Cards
              title="Contributors"
              numCols={2}
              titleDividerColor="#5f606254"
              gapWidth={0.2}
              mobilePadding="60px 0px"
              mdStack
              color="navy"
              emailLength={lengthOfEmail}
            >
              {removeProDups.map(card => (
                <ProfileCard
                  name={card.name}
                  email={card.email}
                  phone={card.phone}
                  person={card}
                  displayAvatar
                  displayName
                  displayTitle
                  displayContact
                  displaySocial
                  key={card.name}
                  id={card.name}
                  defaultFontSize={16}
                />
              ))}
            </Cards>
          </Column>
        )}
      </RowContainer>
    </CardsAndArticleContainer>
  )
}

InsightsDetailNextTeaser.propTypes = {}

export default InsightsDetailNextTeaser
